// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToTop_root__EgcNv","materialOverride":"BackToTop_materialOverride__xIEdz"};